import { resolveAssetPath } from '../../utils/asset-util';
import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
  activeEnvironment: {}
};

const getters = {
  activeEnvironment(state) {
    return state.activeEnvironment;
  }
};

const fallbackEnvironment = {
  _id: '6091945f0d6124001b2a5e11',
  active: true,
  course: 'Not Applicable',
  professor: 'Not Applicable',
  tabText: 'B.L.A.D.E. PLATFORM',
  brand: 'B.L.A.D.E. TECHNOLOGY PLATFORM',
  useInternalHelp: false,
  helpUrl: 'https://redmeru.zendesk.com/hc/en-us/requests/new',
  useInternalFaq: false,
  faqUrl: 'https://redmeru.zendesk.com/hc/en-us',
  reasoningInputOverride: 'Do Not Force',
  faqBackgroundColor: 'white',
  faqTextColor: 'black',
  primaryColor: 'rgba(0,153,165,1)',
  primaryColorLightened: 'rgba(238, 118, 84, 1)',
  neutralColor: 'rgba(238, 118, 84, 1)',
  narratorIconBackgroundColor: 'rgba(238, 118, 84, 1)',
  choiceButtonColor: 'rgba(215, 215, 215, 1)',
  choiceButtonColorLightened: 'rgba(230, 230, 230, 1)',
  choiceButtonActiveColor: 'rgba(255, 255, 255, 1)',
  choiceButtonActiveColorLightened: 'rgba(255, 255, 255, .8)',
  choiceButtonTextColor: 'rgba(17, 17, 17, 1)',
  buttonColor: 'rgba(0,153,165,1)',
  buttonColorLightened: 'rgba(19,196,210,1)',
  buttonTextColor: 'rgba(255, 255, 255, 1)',
  categoryButtonColor: 'rgba(205, 120, 81, 1)',
  categoryButtonColorLightened: 'rgba(245, 155, 115, 1)',
  categoryButtonTextColor: 'rgba(255, 255, 255, 1)',
  categoryButtonUnselectedColor: 'rgba(205, 120, 81, 1)',
  categoryButtonUnselectedColorLightened: 'rgba(245, 155, 115, 1)',
  categoryButtonUnselectedTextColor: 'rgba(255, 255, 255, 1)',
  articleButtonColor: 'rgba(205, 120, 81, 1)',
  articleButtonColorLightened: 'rgba(245, 155, 115, 1)',
  articleButtonTextColor: 'rgba(255, 255, 255, 1)',
  articleButtonUnselectedColor: 'rgba(205, 120, 81, 1)',
  articleButtonUnselectedColorLightened: 'rgba(245, 155, 115, 1)',
  articleButtonUnselectedTextColor: 'rgba(255, 255, 255, 1)',
  secondaryColor: 'rgba(19,196,210,1)',
  secondaryColorLightened: 'rgba(81, 242, 255, .95)',
  secondaryColorTransparent: 'rgba(19, 196, 210, 0.35)',
  primaryBorderColor: 'rgba(0, 225, 243, .95)',
  secondaryBorderColor: 'rgba(81, 242, 255, .95)',
  metricGraphBarColors: '["rgba(78, 91, 127, 1)", "rgba(81, 173, 161, 1)", "rgba(171, 61, 126, 1)"]',
  progressBarForegroundColor: 'rgba(17, 17, 17, 1)',
  progressBarBackgroundColor: 'rgba(17, 17, 17, 1)',
  signInText: 'ERROR: No gamulation branding data has been loaded.  Please report this error to an administrator.',
  signInTextColor: 'rgba(255, 255, 255, 1)',
  gameTitle: 'B.L.A.D.E. TECHNOLOGY PLATFORM',
  revisionText: 'B.L.A.D.E. TECHNOLOGY PLATFORM - (C) 2017-2021',
  creditsText: 'POWERED BY',
  useLightSelectGameText: false,
  gameEndHeader: 'SECTION COMPLETE',
  gameEndSubheader: 'Click on "End" and then "start game" to continue on',
  resultScreenHeader: 'SAMPLE RESULTS SCREEN',
  name: '.BLADE SIGN IN SCREEN ENVIRONMENT',
  titleLogo: 'https://assets.redmeru.com/eai/blade_logos/BLADE-FullWordmark-dark.jpg',
  signInBackground: 'RedU-loginBG01.png',
  signInLogo: 'RedmerU_signinLogo.png',
  creditsLogo: 'https://assets.redmeru.com/eai/blade_logos/BLADE-B-dark.jpg',
  titleBackground: 'https://assets.redmeru.com/eai/ui/customer/Blade_LoginBG_3.png',
  gameEndLogo: 'https://assets.redmeru.com/eai/blade_logos/BLADE-B-dark.jpg',
  reportLogo: 'https://assets.redmeru.com/eai/blade_logos/BLADE-B-dark.jpg',
  updated: {
    $date: '2021-11-22T19:35:14.466Z'
  },
  __v: 0,
  gameBackgroundImage: 'https://assets.redmeru.com/eai/ui/customer/B2_IntroBGBlank.jpg',
  signInBoxBackground: 'https://assets.redmeru.com/eai/ui/customer/Gray_Background.png'
};

const mutations = {
  setActiveEnvironment(state, data) {
    if (!data) {
      // eslint-disable-next-line no-param-reassign
      data = fallbackEnvironment;
    }

    state.activeEnvironment = data;

    // make sure CSS and document vars stay in sync
    if (data != null && data.name != null) {
      document.title = data.tabText;
      document.documentElement.style.setProperty(
        '--gameBackgroundImage',
        ((data.gameBackgroundImage) ? `url('${resolveAssetPath(data.gameBackgroundImage, 'ui/customer')}')` : 'unset')
      );
      const titleBg = resolveAssetPath(data.titleBackground || 'titlescreen_LoginBoxBG1.png', 'ui/RedU');
      // console.log(`title == ${titleBg}`);
      document.documentElement.style.setProperty(
        '--titleBackground', `url('${titleBg}')`
      );
      document.documentElement.style.setProperty(
        '--navBarColor', data.navBarColor || 'rgba(17, 17, 17, 1)'
      );
      document.documentElement.style.setProperty(
        '--navBarDropdownColor', data.navBarDropdownColor || 'rgba(0, 0, 7, 0.76)'
      );
      document.documentElement.style.setProperty(
        '--navBarHoverColor', data.navBarHoverColor || 'rgba(0, 0, 7, 0.3)'
      );
      document.documentElement.style.setProperty(
        '--navBarTextColor', data.navBarTextColor || 'white'
      );
      document.documentElement.style.setProperty(
        '--faqBackgroundColor', data.faqBackgroundColor || 'white'
      );
      document.documentElement.style.setProperty(
        '--faqTextColor', data.faqTextColor || 'black'
      );
      document.documentElement.style.setProperty(
        '--hubHeaderTextColor', data.hubHeaderTextColor || 'white'
      );
      document.documentElement.style.setProperty(
        '--hubHeaderBackgroundColor', data.hubHeaderBackgroundColor || 'rgba(17, 17, 17, 0.4)'
      );
      document.documentElement.style.setProperty(
        '--primaryColor', data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--primaryColorLightened', data.primaryColorLightened || data.primaryColor || 'rgba(245, 155, 115, 1)'
      );
      document.documentElement.style.setProperty(
        '--neutralColor', data.neutralColor || 'rgba(130, 100, 50, 1)'
      );
      document.documentElement.style.setProperty(
        '--narratorIconBackgroundColor', data.narratorIconBackgroundColor || data.primaryColor || 'rgba(170, 135, 84, 1)'
      );
      document.documentElement.style.setProperty(
        '--choiceButtonColor', data.choiceButtonColor || 'rgba(204, 204, 204, 1)'
      );
      document.documentElement.style.setProperty(
        '--choiceButtonColorLightened', data.choiceButtonColorLightened || data.choiceButtonColor || 'rgba(204, 204, 204, 1)'
      );
      document.documentElement.style.setProperty(
        '--choiceButtonActiveColor', data.choiceButtonActiveColor || 'rgba(255, 255, 255, 1)'
      );
      document.documentElement.style.setProperty(
        '--choiceButtonActiveColorLightened',
        data.choiceButtonActiveColorLightened || data.choiceButtonActiveColor || 'rgba(255, 255, 255, 1)'
      );
      document.documentElement.style.setProperty(
        '--choiceButtonTextColor', data.choiceButtonTextColor || 'rgba(56, 70, 80, 1)'
      );
      document.documentElement.style.setProperty(
        '--buttonColor', data.buttonColor || data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--buttonColorLightened',
        data.buttonColorLightened || data.buttonColor || data.primaryColorLightened || data.primaryColor || 'rgba(245, 155, 115, 1)'
      );
      document.documentElement.style.setProperty(
        '--buttonTextColor', data.buttonTextColor || 'rgba(255, 255, 255, 1)'
      );
      document.documentElement.style.setProperty(
        '--categoryButtonColor', data.categoryButtonColor || data.buttonColor || data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--categoryButtonColorLightened',
        data.categoryButtonColorLightened || data.categoryButtonColor || data.buttonColorLightened || data.buttonColor || data.primaryColorLightened || data.primaryColor || 'rgba(245, 155, 115, 1)'
      );
      document.documentElement.style.setProperty(
        '--categoryButtonTextColor', data.categoryButtonTextColor || data.buttonTextColor || 'rgba(255, 255, 255, 1)'
      );
      document.documentElement.style.setProperty(
        '--categoryButtonUnselectedColor', data.categoryButtonUnselectedColor || data.categoryButtonColor || data.buttonColor || data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--categoryButtonUnselectedColorLightened',
        data.categoryButtonUnselectedColorLightened || data.categoryButtonColorLightened || data.categoryButtonColor || data.buttonColorLightened || data.buttonColor || data.primaryColorLightened || data.primaryColor || 'rgba(245, 155, 115, 1)'
      );
      document.documentElement.style.setProperty(
        '--categoryButtonUnselectedTextColor', data.categoryButtonUnselectedTextColor || data.categoryButtonTextColor || data.buttonTextColor || 'rgba(255, 255, 255, 1)'
      );
      document.documentElement.style.setProperty(
        '--articleButtonColor', data.articleButtonColor || data.buttonColor || data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--articleButtonColorLightened',
        data.articleButtonColorLightened || data.articleButtonColor || data.buttonColorLightened || data.buttonColor || data.primaryColorLightened || data.primaryColor || 'rgba(245, 155, 115, 1)'
      );
      document.documentElement.style.setProperty(
        '--articleButtonTextColor', data.articleButtonTextColor || data.buttonTextColor || 'rgba(255, 255, 255, 1)'
      );
      document.documentElement.style.setProperty(
        '--articleButtonUnselectedColor', data.articleButtonUnselectedColor || data.articleButtonColor || data.buttonColor || data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--articleButtonUnselectedColorLightened',
        data.articleButtonUnselectedColorLightened || data.articleButtonColorLightened || data.articleButtonColor || data.buttonColorLightened || data.buttonColor || data.primaryColorLightened || data.primaryColor || 'rgba(245, 155, 115, 1)'
      );
      document.documentElement.style.setProperty(
        '--articleButtonUnselectedTextColor', data.articleButtonUnselectedTextColor || data.articleButtonTextColor || data.buttonTextColor || 'rgba(255, 255, 255, 1)'
      );
      document.documentElement.style.setProperty(
        '--primaryBorderColor', data.primaryBorderColor || data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--secondaryColor', data.secondaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--secondaryBorderColor', data.secondaryBorderColor || data.secondaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--secondaryColorLightened', data.secondaryColorLightened || data.secondaryColor || 'rgba(245, 155, 115, 1)'
      );
      document.documentElement.style.setProperty(
        '--secondaryColorTransparent', data.secondaryColorTransparent || data.secondaryColor || 'rgba(205, 120, 81, 0.35)'
      );
      document.documentElement.style.setProperty(
        '--allocationActiveDetailsButtonColor', data.allocationActiveDetailsButtonColor || '#8774AC'
      );
      document.documentElement.style.setProperty(
        '--allocationInactiveDetailsButtonColor',
        data.allocationInactiveDetailsButtonColor || data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--allocationActiveDetailsBackgroundColor', data.allocationActiveDetailsBackgroundColor || '#3b1d73'
      );
      document.documentElement.style.setProperty(
        '--allocationPerformanceBarBackgroundColor', data.allocationPerformanceBarBackgroundColor || '#745E9C'
      );
      document.documentElement.style.setProperty(
        '--progressBarForegroundColor', data.progressBarForegroundColor || data.primaryColor || 'rgba(205, 120, 81, 1)'
      );
      document.documentElement.style.setProperty(
        '--progressBarBackgroundColor', data.progressBarBackgroundColor || data.secondaryColorTransparent || 'rgba(205, 120, 81, 0.35)'
      );
    }
  }
};


const environmentCache = new Map();
const actions = {
  async createEnvironment(_, environment) {
    const response = await axios.post('/blade/environments', environment);
    return response.data.environment;
  },
  async getEnvironments() {
    const response = await axios.get('/blade/environments');
    return response.data.environments;
  },
  async getEnvironment(_, { environmentId }) {
    const { data } = await axios.get(`/blade/environments/${environmentId}`);
    return data;
  },
  async getActiveEnvironment(context, { path } = {}) {
    let endpoint = '/blade/environmentActive';
    // console.log(path);
    if (!path || path.startsWith('/groups/')) {
      if (context.getters.roleSelectOutroViewed && context.getters.allPlayersHere
        && context.getters.challenge != null && context.getters.challenge.environment) {
        // console.log(context.getters.challenge.environment);
        endpoint = `/blade/environments/${context.getters.challenge.environment._id || context.getters.challenge.environment}`;
      } else if (context.getters.activeClass != null && context.getters.activeClass.environment) {
        // console.log(context.getters.activeClass.environment);
        endpoint = `/blade/environments/${context.getters.activeClass.environment._id || context.getters.activeClass.environment}`;
      } else if (context.getters.game != null && context.getters.game.environment != null) {
        // console.log(context.getters.game.environment);
        endpoint = `/blade/environments/${context.getters.game.environment._id || context.getters.game.environment}`;
      }
    } else if (context.getters.activeSignInConfig
      && context.getters.activeSignInConfig.environment) {
      context.commit('setActiveEnvironment', context.getters.activeSignInConfig.environment);
      return context.getters.activeSignInConfig.environment;
    }

    let environment = endpoint !== '/blade/environmentActive' ? environmentCache.get(endpoint) : undefined;
    if (!environment) {
      console.log(`fetching uncached environment from ${endpoint}`);
      const { data } = await axios.get(endpoint);
      environment = data.environment;
      environmentCache.set(endpoint, environment);
    } else {
      console.log(`using cached environment from ${endpoint}`);
    }
    context.commit('setActiveEnvironment', environment);
    return environment;
  },
  async getEnvironmentTypes({ dispatch }) {
    return dispatch('getEnvironment', { environmentId: 'types' });
  },
  async getEnvironmentEnums() {
    const { data } = await axios.get('/blade/environmentEnums');
    return data;
  },
  async updateEnvironment(_, environment) {
    const response = await axios.patch(`/blade/environments/${environment._id}`, environment);
    return response.data.environment;
  },
  async deleteEnvironment(_, { environmentId, _id }) {
    const did = environmentId || _id;
    const response = await axios.delete(`/blade/environments/${did}`);
    return response.data.environment;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/environments.js